
<script>
// 从环境变量读取API基础地址
const base = process.env.VUE_APP_API_BASE_URL

export default {
  base
}

</script>
